{
  "add": "Add",
  "button_aria_label": "Add",
  "manual": "Add manually instead",
  "placeholder": "Try 'practice tomorrow at 8am'",
  "submit": "🪄 Create",
  "tip": {
    "tip": "💡 Tip!",
    "shift": "shift",
    "enter": "enter",
    "to_submit": "to create"
  }
}
